import type {
    AreaFilterItemsParams,
    AreaFilterSectionParams,
    TSettingsMenuItem,
    TSettingsMenuSection,
} from '../../types';

const buildAreaFilterItems = ({
    areas,
    selectedArea,
    onAreaChange,
    t,
}: AreaFilterItemsParams): TSettingsMenuItem[] => [
    {
        label: t('AdvancedAll.Areas'),
        onClick: () => onAreaChange?.(''),
        isActive: selectedArea === '',
    },
    ...areas.map((area) => ({
        label: String(t(`Areas.${area}`, area)),
        onClick: () => onAreaChange?.(area),
        isActive: selectedArea === area,
    })),
];

export const getAreaFilterSection = ({
    show,
    areas,
    selectedArea,
    onAreaChange,
    t,
}: AreaFilterSectionParams): TSettingsMenuSection[] => {
    if (!show) return [];

    return [
        { divider: true },
        {
            title: t('Chat.FilterAreas'),
            items: buildAreaFilterItems({
                areas,
                selectedArea,
                onAreaChange,
                t,
            }),
        },
    ];
};
